import { render, staticRenderFns } from "./matapelajaran.vue?vue&type=template&id=d5769fdc&"
import script from "./matapelajaran.vue?vue&type=script&lang=js&"
export * from "./matapelajaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports